<template>
  <section>
    <modal v-model="open" class="custom-modal" :footer="false">
      <span slot="title">BŁĘDNIE WPROWADZONE DANE</span>
      <h4>Prosimy poprawić następujące błedy:</h4>
      <ul class="errors">
        <li v-for="(error, index) in errors" :key="index">{{error}}</li>
      </ul>
      <div class="custom-modal__controls">
        <btn @click="$emit('update:open', false)" class="btn btn-primary">OK</btn>
      </div>
    </modal>
  </section>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: ['errors', 'open'],
  data() {
    return {
      open1: true,
    };
  },
};
</script>

<style scoped>

</style>
